import { Capacitor } from '@capacitor/core';
import { Badge } from '@capawesome/capacitor-badge';
import ApiUsersManager from 'services/api/ApiUsersManager';
import Platform from './Platform';

/**
 * Fetch the current user's badge_count from the server and apply it to the OS
 * app icon. Unlike a silent push (which the server sends on relevant events),
 * this is synchronous from the caller's point of view, so it's used right
 * after actions we know changed the count (e.g. marking a conversation as
 * read) instead of waiting on a Cloud Task + push round trip that can race
 * with other badge updates or simply arrive late.
 */
export default function syncBadgeCount(): void {
  if (!Platform.isNative() || !Capacitor.isPluginAvailable('Badge')) return;

  ApiUsersManager.getBadgeCount()
    .then(({ badge_count: badgeCount }) => Badge.set({ count: badgeCount }))
    .catch(() => {
      // Best-effort: a stale badge is preferable to a crash.
    });
}
